import React from "react";
import "./styles.scss";

const Index = ({header}) => {
  let inputElement = null;
  inputElement = (
      <>
        <div className={`section__header-block`}>
          <h2>{header}</h2>
        </div>
      </>
  );
  return <>{inputElement}</>;
};

export default Index;
